import { Box } from "@mui/material";
import * as React from "react";
import { SearchBar } from "../../SearchBar";
import { useLocationConfiguration } from "../../LocationConfiguration";
import { useSyndeticsConfig } from "../../SyndeticsConfig";
import { LS2PacSearchDatabaseManager } from "@tlc/ls2pac/app/managers/SearchDatabaseManager";
import { LS2PAC_CONSTANTS } from "src/main/resources/js/main/constants";
import { TLCEventManager } from "../../../events/EventManager";
import { LS2PAC_Utils } from "@tlc/ls2pac/app/utils/Utils";
import SearchBarContainer from "../../SearchBarContainer";

export const SearchPage: React.FC = () => {
  const { locationConfiguration } = useLocationConfiguration();
  const { syndeticsConfig } = useSyndeticsConfig();

  return (
    <SearchBarContainer>
      <SearchBar
        autoFocus={true}
        sx={{ m: "0 auto" }}
        limitToKids={false}
        voiceSearchEnabled={
          locationConfiguration?.pacSettings?.displaySettings?.voiceInterface
        }
        onClickSearch={(searchEvent) => {
          const currentDatabaseConfig =
            LS2PacSearchDatabaseManager.getCurrentDatabaseConfig();
          if (!currentDatabaseConfig.requiresSearchTerm) {
            LS2PacSearchDatabaseManager.setCurrentDatabaseKey(
              LS2PAC_CONSTANTS.Ids.SearchPage.Tabs.ls2pac.key
            );
          }
          const event = {
            searchString: searchEvent.searchTerm,
            searchType: "",
          };
          if (searchEvent.searchType === "author") {
            event.searchType = "author";
          }
          TLCEventManager.fireEvent(LS2PAC_CONSTANTS.Events.onSearch, event);
        }}
        onClickTitle={(resource) => {
          var data = LS2PAC_Utils.getFakePagingDataToSendToFullDetails([
            resource,
          ]);
          window.location.href = `#section=resource&resourceid=${resource.id}&currentIndex=0&view=fullDetailsDetailsTab`;
        }}
        syndeticsClientCode={syndeticsConfig?.clientCode}
        branchFilters={locationConfiguration?.filterBranches}
      ></SearchBar>
    </SearchBarContainer>
  );
};
